<template>
    <div>
        <buttonlist
                @help="help"
                @opentable="opentable"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                ref="SetBtn"
        ></buttonlist>

        <div style="margin-top: 2px">
        <el-button type="primary" size="mini"  @click="ToStore" :disabled="!btn.inStore">{{$t('getapi[4951]')}}</el-button>
        <el-button type="primary" size="mini" @click="delline" :disabled="!btn.delete">{{$t('getapi[40]')}}</el-button>
        <el-button type="primary" size="mini" @click="showDialog" :disabled="!btn.transget">{{$t('getapi[8845]')}}</el-button>
            <el-button type="primary" size="mini" @click="reSetting" :disabled="!btn.resetting">{{$t('getapi[12825]')}}</el-button>
        </div>
        <wTable
                id="xpane-0"
                :data="dataSet"
                :loading="loading"
                queryData="PropartViewInfo"
                :filter_thousandth="['pos_qty']"
                :header="tableHeader"
                :option="tableOption"
                @handleSelectionChange="handleSelectionChange"
                ref="singleTable"
        ></wTable>
        <!--<el-table
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                :row-class-name="tableRowClassName"
                @selection-change="handleSelectionChange"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:0px"
        >
        <el-table-column type="selection"></el-table-column>
            <el-table-column show-overflow-tooltip prop="so_CODE" :label="$t('getapi[4208]')" width="150"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" width="150"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')" width="80"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pos_qty" :label="$t('getapi[3101]')" width="50" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="shop_position_code" :label="$t('getapi[1882]')" width="80"></el-table-column>
            <el-table-column show-overflow-tooltip prop="shop_position_name" :label="$t('getapi[3471]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pos_type" :label="$t('getapi[867]')" width="80"></el-table-column>
            <el-table-column show-overflow-tooltip prop="routing_sequence_No" :label="$t('getapi[573]')" width="60" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="WORKPROC_NAME" :label="$t('getapi[574]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="batch_no" :label="$t('getapi[1763]')" width="50"></el-table-column>
            <el-table-column show-overflow-tooltip prop="sequence_no" :label="$t('getapi[1764]')" width="50"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Schedule_No" :label="$t('getapi[4209]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[135]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[410]')" width="80"></el-table-column>
            <el-table-column show-overflow-tooltip prop="modify_time" :label="$t('getapi[1210]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[733]')" width="80"></el-table-column>
        </el-table>-->
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="PropartViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[4033]')" queryData="PropartViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        <el-dialog v-dialogDrag :visible.sync="visReplacePart" :title="$t('getapi[8846]')" width="20%" :close-on-click-modal="false" >
            <div class="box" style="margin-top:5px">
            <div class="bbl">
            <span>{{$t('getapi[1628]')}}</span>
            <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" style="width: 200px;" v-model="transobj.Qty" ></el-input>
            
            </div>
            <div class="bbl">
            <span>{{$t('getapi[2180]')}}</span>
            <el-select filterable popper-class="select-option" style="width: 200px;"
                        v-model="transobj.cmbIssue_Dept"
                         size="mini">
                <el-option v-for="item in DeptList" 
                           :key="item.Code"
                           :label="item.Name"
                           :value="item.Name"></el-option>
              </el-select>
            </div>
            </div>
            <span slot="footer" class="dialog-footer">
                    <el-button type="primary" size="mini"  @click="confirmtrans">{{$t('getapi[1146]')}}</el-button>
            </span>

        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="visReSetting" :title="$t('getapi[12825]')" width="20%" :close-on-click-modal="false" >
            <div class="box" style="margin-top:5px">
                <div class="bbl">
                    <span>{{$t('getapi[1628]')}}</span>
                    <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" style="width: 200px;" v-model="transobj.Qty" ></el-input>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                 <el-button type="primary" size="mini"  @click="confirmReSetting">{{$t('getapi[1146]')}}</el-button>
            </span>
        </el-dialog>
    </div>


</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name:'2_cjhw',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3- Common.reduceTableHeight3,
                    maxHeight: this.$windowSize.tableHeight3- Common.reduceTableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3- Common.reduceTableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                visReplacePart:false,
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('cjhw'), // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                selectData: [],
                DeptList:[],//领料部门数组
                transobj:{
                    Qty: 0,
                    cmbIssue_Dept: "",
                    tempQty: 0,
                    so_code: '',
                    Flag: -1,
                    Exclusively_ID: 0,
                    LangType:0,
                },
                btn:{
                    endIssue: false,
                    inStore:false,
                    delete: false,
                    transget:false,
                    resetting: false,
                },
                scrollTop:0,
                visReSetting: false,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function() {
            let that = this;
            that.colsort();
            that.userData = sessionStorage.getItem('userData');
            that.PlanTypeArray = Array.methods.getPlanType();
            that.transobj.cmbIssue_Dept = that.DeptList[0].Name;
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        created: function(){
            this.DeptList = Array.methods.getIssueDeptList();
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('PropartViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[4033]"),this.$t("getapi[20]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                //只读权
                if (that.$limits.ReadOnlyRightsView('plv2', 203, 1, that.total)) {
                    if (that.total > 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    } else {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                    }
                }
                //操作权限-查询级别
                var limits = that.$limits.OperationAuthorityView('plv2', 203, 1, that.total);
                // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
                switch (limits) {
                    case -1:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        break;
                    case 1:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        break;
                    case -2:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        break;
                    case 2:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        break;
                    case -3:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        break;
                    case 3:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        break;
                    default:
                        break;
                }
                that.btnauthority();
            },
            btnauthority(){
                let that = this;
                that.btn.delete = false;
                that.btn.transget = false;
                that.btn.resetting = false
                that.btn.inStore = false;
                if(that.selectData.length > 0){
                    if (that.$limits.authority('plv4', 359, 1) == 1) {
                        that.$http.urlpost('/Pro/MDIP/ChangeReceiveInCheck', that.selectData, function(res) {
                            if (res.Success == 1) {
                                if(!that.$limits.fnIsEmpty(res.UniqueNum)){
                                    that.btn.inStore = true;
                                }
                            } 
                        });
                    }
                    if (that.$limits.authority('plv4', 105, 1) == 1) {
                         that.btn.transget = true;
                    }
                    if (that.$limits.authority('plv4', 226, 1) == 1) {
                        that.btn.resetting = true;
                    }
                    if (that.$limits.authority('plv4', 87, 1) == 1) {
                        let Login_Code = JSON.parse(that.userData).Login_Code;
                        if(Login_Code=='boss'){
                             that.btn.delete = true;
                        }
                    }

                    let Login_Code1 = JSON.parse(that.userData).Login_Code;
                    if(Login_Code1=='boss'){
                            that.btn.delete = true;
                    }

                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('cjhw',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'PropartViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.pageIndex = 1;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let token = JSON.parse(that.userData).token;
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Pro/MDIP/ProPartViewDataList', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/Pro/MDIP/ProPartExportToExecl', parm, function(res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "PropartViewInfo",
                    fromname: that.$t('getapi[4033]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            handleSelectionChange(val){
                let that = this;
                that.selectData = val;
                that.btnauthority()
            },
            tableRowClassName({ row, rowIndex }) {
            row.index = rowIndex;
            },
            delline() {
            let that = this;

            let parm={
            ids:'',
            };
            for(let i=0;i<that.selectData.length;i++){
                parm.ids+=that.selectData[i].so_CODE+',';

            }
            parm.ids =  parm.ids.substring(0, parm.ids.length - 1);

            that.$http.urlpost('/Pro/MDIP/ProPartDelete', parm, function (res) {
                if (res.Success == 1) {
                    that.$message.success(that.$t('getapi[659]'));//'删除成功'
                    that.getView();
                }
            });
            
            // for (let i = that.selectData.length - 1; i >= 0; i--) {
            // that.dataSet.splice(that.selectData[i].index, 1);
            // }



            },
            ToStore(){
                let that = this;
                let parm = {
                    Flag: 0,
                    SelectedRows: []
                }
                parm.SelectedRows = that.selectData;
                parm.LangType = that.$processdata.getLang()
                that.$http.urlpost('/Pro/MDIP/ChangeReceiveIn', parm, function (res) {
                if(res.Success == 1){
                that.$message.success(that.$t('getapi[321]'));//'设置成功！'
                that.getView();
                }else if (res.Success == 2) {
                //that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                //弹框 
                //确认
                const newDatas = []
                const h = that.$createElement;
                newDatas.push(h('p', null, that.$processdata.explainCallbackMsg(res.Msg)));
                parm.Flag=1;
                parm.LangType = that.$processdata.getLang()
                that.$confirm(
                h('div', null, newDatas), that.$t('getapi[241]'), {
                confirmButtonText: that.$t('getapi[1146]'),
                cancelButtonText: that.$t('getapi[2054]'),
                type: 'warning',
                })
                .then(() => {
                that.$http.urlpost('/Pro/MDIP/ChangeReceiveIn', parm, function(res) {
                if (res.Success == 1) {
                that.$message.success(that.$t('getapi[321]'));//'设置成功！'
                that.getView();

                }
                });

                })
                .catch(() => {
                this.$message({
                type: 'info',
                message: that.$t('getapi[6096]')
                });
                });

                //取消
                }
                });


            },
            showDialog(){
                let that = this;
                that.visReplacePart = true;
                that.transobj.Qty = that.selectData[0].pos_qty;
            },
            confirmtrans(){
                let that = this;
                if(that.selectData.length>1){
                    that.$message.warning(that.$t('getapi[8756]'));//请选择一条数据
                    return;
                }
                that.transobj.tempQty = that.selectData[0].pos_qty;
                that.transobj.so_code= that.selectData[0].so_CODE;
                that.transobj.Exclusively_ID = that.selectData[0].exclusively_id;
                that.transobj.LangType=that.$processdata.getLang()
                that.transobj.Flag = -1,
                that.$http.urlpost('/Pro/MDIP/IssMoveCF', that.transobj, function (res) {
                if (res.Success == 1) {
                that.$message.success(that.$t('getapi[321]'));//'设置成功！'
                that.getView();
                //reset
                that.transobj = {
                    Qty: 0,
                    cmbIssue_Dept: that.DeptList[0].Name,
                    tempQty: 0,
                    so_code: '',
                    Exclusively_ID: 0
                    }
                } 
                });

            },
            endIssue(){
                let that = this
                let arr = []
                for(let i = 0;i<that.selectData.length;i++){
                    arr = [...arr,{
                        so_code: that.selectData[i].so_code,
                        part_id: that.selectData[i].part_id
                    }]
                }
                let parm = {
                    Lists: arr
                }
                that.$http.urlpost('/Pro/SO/SOMaterilEndIssue', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    }
                });
            },
            reSetting(){
                let that = this;
                that.visReSetting = true;
                that.transobj.Qty = that.selectData[0].pos_qty;
            },
            confirmReSetting(){
                let that = this
                if(that.selectData.length>1){
                    that.$message.warning(that.$t('getapi[8756]'));//请选择一条数据
                    return;
                }
                this.$confirm(that.$t('getapi[12826]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.transobj.so_code= that.selectData[0].so_CODE;
                        that.transobj.Exclusively_ID = that.selectData[0].exclusively_id;
                        that.transobj.LangType=that.$processdata.getLang()
                        that.transobj.Flag = -2
                        that.$http.urlpost('/Pro/MDIP/IssMoveCF', that.transobj, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$t('getapi[321]'));//'设置成功！'
                                that.getView();
                            }
                            that.visReSetting = false
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });
            }
        }
    };
</script>

<style scoped lang="less">
span.title {
	width: 100%;
	display: flex;
	height: 40px;
	line-height: 40px;
}

span.title .el-switch {
	display: inline-block;
	margin: 8px 30px;
}
.box {
	width: 100%;
	overflow-x: auto;
	.bbl {
		margin: 0px auto 10px;
		white-space: pre;
		span {
			margin-left: 10px;
			min-width: 70px;
			text-align: left;
			line-height: 20px;
			display: inline-block;
			margin-right: 0px;
		}
    }
}
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
